import "./MasterGpGallery.css";

import m1 from "../../assets/m1.png";
import m2 from "../../assets/m2.png";
import m3 from "../../assets/m3.png";
import m4 from "../../assets/m4.png";
import m5 from "../../assets/m5.png";
import m6 from "../../assets/m6.png";
import m7 from "../../assets/m7.png";
import m8 from "../../assets/m8.png";
import m9 from "../../assets/m9.png";
import m10 from "../../assets/m10.png";
import m11 from "../../assets/m11.png";
import m12 from "../../assets/m12.png";
import m13 from "../../assets/m13.png";
import m14 from "../../assets/m14.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import i18n from "../../languages/i18n";
import { useTranslation } from "react-i18next";

const MasterGpGallery = ({ show, handleClose,onscrollHandler }) => {
  const showHideClassName = show
    ? "modalTesti display-block"
    : "modalTesti display-none";
  const { t } = useTranslation();

  return (
    <div className={showHideClassName} onWheel={onscrollHandler}>
      <div className="modalGallery-main ">
        <h2 className="title_h2">Master GP Gallery</h2>
        <div className="container gallery-container ">
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            navigation
            pagination
            spaceBetween={20}
            slidesPerView={1}
            onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => console.log(swiper)}
            className="swiperGallery"
          >
            <SwiperSlide >
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/1Ybk0Z_wyTc"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m1} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m2} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m3} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m4} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m5} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m6} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m7} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m8} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m9} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m10} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m11} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m12} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m13} className="photo" alt=""/>
            </SwiperSlide>
            <SwiperSlide className="slideGallery">
              <img src={m14} className="photo" alt=""/>
            </SwiperSlide>
          </Swiper>
          <div
            className="btn_container"
          >
            <button
              type="submit"
              className={
                i18n.language == "en"
                  ? "btn btn-primary"
                  : "btn btn-primary arabicText"
              }
              onClick={handleClose}
            >
              {t("btn_close_title")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterGpGallery;
